module.exports = __webpack_public_path__ + "static/media/Building.505abeec.png";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/Building.png
// module id = 66
// module chunks = 0